import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchBlogPosts } from '../../services/BlogService';

const AllBlogs = () => {
    const [allBlogs, setAllBlogs] = useState([]);

    useEffect(() => {

        const loadAllBlogs = async () => {
            try {
                const data = await fetchBlogPosts(); // Use the API function
                setAllBlogs(data);
            } catch (error) {
                console.error('Error loading latest channels:', error);
            }
        };

        loadAllBlogs();

    }, []);

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>Blogs</h2>
                        </div>
                    </div>

                    {allBlogs.length === 0 ? (
                        <div className="col-12">
                            <p>No any blogs found.</p>
                        </div>
                    ) : (
                        allBlogs.map((blog) => (
                            <div class="col-12 col-sm-6 col-lg-4">
                                <div class="post">
                                    <Link to={`/blog/${blog.slug}`} class="post__img">
                                        <img src={blog.image} alt=""/>
                                    </Link>
    
                                    <div class="post__content">
                                        <Link to="#" class="post__category">{blog.category.name}</Link>
                                        <h3 class="post__title"><Link to={`/blog/${blog.slug}`}>{blog.title}</Link></h3>
                                        <div class="post__meta">
                                            <span class="post__date"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20ZM14.09814,9.63379,13,10.26807V7a1,1,0,0,0-2,0v5a1.00025,1.00025,0,0,0,1.5.86621l2.59814-1.5a1.00016,1.00016,0,1,0-1-1.73242Z"/></svg> {blog.published_at}</span>
                                            <span class="post__comments"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,9H7a1,1,0,0,0,0,2H17a1,1,0,0,0,0-2Zm-4,4H7a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM12,2A10,10,0,0,0,2,12a9.89,9.89,0,0,0,2.26,6.33l-2,2a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22h9A10,10,0,0,0,12,2Zm0,18H5.41l.93-.93a1,1,0,0,0,0-1.41A8,8,0,1,1,12,20Z"></path></svg> 18</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="partners owl-carousel">
                        
                    </div>
                </div>
            </div>
        </main>
    );
};

export default AllBlogs;
